
import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

import { executeListener } from '@/util'
import WeveDragHandle from '@/components/WeveDragHandle/WeveDragHandle'
import WeveButtonDelete from '@/components/WeveButtonDelete/WeveButtonDelete'
import WeveButtonIconCopy from '@/components/WeveButtonIconCopy/WeveButtonIconCopy'

export default Vue.extend({
  name: 'SidebarListItem',
  functional: true,
  props: {
    draggable: {
      type: Boolean,
      default: false,
    },
    identity: {
      type: [String, Number],
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: true,
    },
    editOnClick: {
      type: Boolean,
      default: false,
    },
  },
  render(h, { props, data, children, listeners }) {
    const up = {
      relative: props.editOnClick,
      'z-1': props.editOnClick,
    }

    return h(
      'li',
      mergeData(data, {
        attrs: { 'data-id': props.identity },
        staticClass: 'sidebar-list__item relative pl-4 rounded',
      }),
      [
        h('div', { staticClass: 'flex items-center py-1' }, [
          h('div', { staticClass: 'grow text-sm text-neutral-8' }, children),
          h(
            'div',
            {
              staticClass: 'ml-auto shrink-0',
              class: {
                relative: props.editOnClick === false,
                'z-1': props.editOnClick === false,
              },
            },
            [
              props.draggable
                ? h(WeveDragHandle, {
                    class: up,
                    staticClass: '-mr-1',
                  })
                : null,
              props.copyable
                ? h(WeveButtonIconCopy, {
                    class: up,
                    props: { size: 'sm' },
                    on: { click: () => executeListener(listeners.copy) },
                  })
                : null,
              props.editable
                ? h(
                    'button',
                    {
                      attrs: { type: 'button' },
                      staticClass:
                        'absolute top-0 left-0 w-full h-full borer-0 opacity-0 cursor-pointer',
                      on: { click: () => executeListener(listeners.edit) },
                    },
                    'Edit'
                  )
                : null,
              props.deletable
                ? h(WeveButtonDelete, {
                    class: up,
                    on: { click: () => executeListener(listeners.delete) },
                  })
                : null,
            ]
          ),
        ]),
      ]
    )
  },
})
